export const NDA_URL = 'https://www.playbookux.com/nda/';
